import moment from 'moment'
import store from '@/store/app'

export const products = {'product-single-0':'Single Trip Value','product-single-1':'Single Trip Silver','product-single-2':'Single Trip Gold','product-single-4':'Single Trip Gold','product-custom-108':'Seajet','product-longstay-1':'Longstay Standard','product-longstay-2':'Longstay Study','product-annual-1':'Silver Annual Multi Trip','product-annual-2':'Gold Annual Multi Trip','product-single-500':'Single Trip Essential Schengen','product-single-501':'Single Trip Silver Inbound','product-single-502':'Single Trip Gold Inbound','product-single-100':'Lets Go Tours','product-single-700':'Value Collinson','product-single-701':'Silver Collinson','product-single-702':'Gold Collinson','product-single-703':'Silver without Cancellation Collinson','product-single-704':'Gold without Cancellation Collinson','product-annual-701':'Silver AMT Collinson','product-annual-702':'Gold AMT Collinson','product-longstay-701':'Long Stay Standard Collinson','product-longstay-702':'Long Stay Study Collinson','product-single-705':'Lets Go','product-single-707':'Lets Go 2023','product-single-6400':'Globy Classic','product-single-6403':'Super Globy','product-single-6535':'Super Globy Plus','product-single-6407':'Globy Schengen','product-single-6418':'Globy Classic & Ski','product-single-6419':'Globy Cancellation','product-single-6421':'Super Globy & Ski','product-single-6440':'Globy Student Extended','product-single-6442':'Globy Annual','product-single-6499':'Globy Visa','product-single-6520':'Globy Annual Business Plus','product-single-6540':'Globy Annual Business','product-single-6583':'Globy Student Extended Plus','product-single-807':'Basic Single Trip','product-single-808':'Standard Single Trip','product-single-809':'Luxury Single Trip','product-single-810':'Visa Schengen & Russian', 'product-single-811':'Basic Winter Sports Single Trip','product-single-812':'Luxury Winter Sports Single Trip','product-single-401':'Lloyd\'s Battleface Basic','product-single-402':'Lloyd\'s Battleface Extended', 'product-single-712':'School Trips','product-single-403':'Lloyd\'s Battleface Luxury', 'product-single-404':'Lloyd\'s Battleface Business Basic', 'product-single-405':'Lloyd\'s Battleface Business Extended', 'product-single-406':'Lloyd\'s Battleface Extended incl. Winter Sports', 'product-single-407':'Lloyd\'s Battleface Luxury inc Winter Sports', 'product-single-408':'Crum & Forster Leisure Battleface', 'product-single-409':'Crum & Forster Business Battleface', 'product-single-410':'Crum & Forster Winter Sports Battleface','product-single-708':'Silver Winter Sports','product-single-709':'Gold Winter Sports','product-single-710':'Silver Business','product-single-711':'Gold Business','product-single-713':'Visit Greece','product-single-714':'Visit Europe','product-single-715':'Cruises','product-single-706':'Silver','product-longstay-901':'Long Stay Standard Hannover','product-longstay-902':'Long Stay Study Hannover','product-annual-901':'Silver AMT Hannover','product-annual-902':'Gold AMT Hannover','product-annual-910':'Silver AMT Business','product-annual-911':'Gold AMT Business','product-single-900':'Value Hannover','product-single-901':'Silver Hannover','product-single-902':'Gold Hannover','product-single-903':'Silver without Cancellation Hannover','product-single-904':'Gold without Cancellation Hannover','product-single-905':'Lets Go','product-single-906':'Silver','product-single-907':'Lets Go 2023','product-single-908':'Silver Winter Sports','product-single-909':'Gold Winter Sports','product-single-910':'Silver Business','product-single-911':'Gold Business','product-single-912':'School Trips','product-single-913':'Visit Greece','product-single-914':'Visit Europe','product-single-915':'Cruises','product-single-916':'All About Travel','product-single-917':'Lets Go 2024','product-single-918':'Summer by Lets Go','product-single-920':'Cruises 2024','product-single-919':'School Trips 2024','product-single-300':'Basic','product-single-301':'Extended','product-single-302':'Extended Winter Sports','product-single-303':'Luxury','product-single-304':'Luxury Winter Sports','product-single-305':'Business Extended','product-single-306':' Business Basic','product-single-307':'Leisure','product-annual-301':'AMT Basic','product-annual-302':'AMT Extended','product-longstay-301':'Study','product-longstay-302':'Study Extended','product-annual-303':'AMT Basic (incl. Winter Sports)','product-annual-304':'AMT Extended (incl. Winter Sports)','product-single-308':'Summer by Lets Go','product-annual-305':'AMT Business Basic'};

export const product_documents = {
        'product-single-900' : {
                'tob_title': 'VALUE TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_VALUE_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Value Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Value_GLOBEINSURE.pdf'
        },
        'product-single-912' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-919' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-913' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-914' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-915' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-920' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-916' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-917' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-918' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-901' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-902' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-single-909' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-single-911' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-single-903' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-908' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-910' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-904' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-single-905' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-906' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-6400' : {
                'tob_title': 'Globy Classic',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6400.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6400.pdf',
                'ipid_title': 'Globy Classic IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6400.pdf'
        },
        'product-single-6403' : {
                'tob_title': 'Super Globy',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6403.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6403.pdf',
                'ipid_title': 'Super Globy IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6403.pdf'
        },
        'product-single-6535' : {
                'tob_title': 'Super Globy Plus',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6535.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6535.pdf',
                'ipid_title': 'Super Globy Plus IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6535.pdf'
        },
        'product-single-6419' : {
                'tob_title': 'Globy Cancellation',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6419.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6419.pdf',
                'ipid_title': 'Globy Cancellation IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6419.pdf'
        },
        'product-single-6499' : {
                'tob_title': 'Globy Visa',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6499.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6499.pdf',
                'ipid_title': 'Globy Visa IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6499.pdf'
        },
        'product-longstay-901' : {
                'tob_title': 'LONG STAY STANDARD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_LONG_STAY_STANDARD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Long Stay Standard',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Long_Stay_Standard_GLOBEINSURE.pdf'
        },
        'product-longstay-902' : {
                'tob_title': 'LONG STAY STUDY TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_LONG_STAY_STUDY_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Long Stay Study',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Long_Stay_Study_GLOBEINSURE.pdf'
        },
        'product-single-6440' : {
                'tob_title': 'Globy Student Extended',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6440.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6440.pdf',
                'ipid_title': 'Globy Student Extended IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6440.pdf'
        },
        'product-single-6583' : {
                'tob_title': 'Globy Student Extended Plus',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6583.pdf',
                'pwo_title': 'Globelink Greek Policy Wording',
                'pwo_link': 'https://quote.safetravel.today/files/schedules/6583.pdf',
                'ipid_title': 'Globy Student Extended Plus IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6583.pdf'
        },
        'product-annual-901' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-annual-910' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-annual-902' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-annual-911' : {
                'tob_title': 'GOLD TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_GOLD_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Gold Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Gold_GLOBEINSURE.pdf'
        },
        'product-annual-6442' : {
                'tob_title': 'Globy Annual',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6442.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6442.pdf',
                'ipid_title': 'Globy Annual IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6442.pdf'
        },
        'product-annual-6540' : {
                'tob_title': 'Globy Annual Business',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6540.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6540.pdf',
                'ipid_title': 'Globy Annual Business IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6540.pdf'
        },
        'product-single-6520' : {
                'tob_title': 'Globy Annual Business Plus',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6520.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6520.pdf',
                'ipid_title': 'Globy Annual Business Plus IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6520.pdf'
        },
        'product-single-907' : {
                'tob_title': 'SILVER TRAVEL INSURANCE',
                'tob_link': 'https://quote.safetravel.today/files/schedules/TOB_SILVER_GLOBEINSURE.pdf',
                'pwo_title':'Globelink Greek Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/Globeinsure_Policy_Wording.pdf',
                'ipid_title': 'Silver Cover',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_Silver_GLOBEINSURE.pdf'
        },
        'product-single-6418' : {
                'tob_title': 'Globy Classic & Ski',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6418.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6418.pdf',
                'ipid_title': 'Globy Classic & Ski IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6418.pdf'
        },
        'product-single-6421' : {
                'tob_title': 'Super Globy & Ski Visa',
                'tob_link': 'https://quote.safetravel.today/files/schedules/6421.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/schedules/6421.pdf',
                'ipid_title': 'Super Globy & Ski Visa IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/IPID_6421.pdf'
        },
        'product-single-807' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-808' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-809' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-810' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-811' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-812' : {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/KCNPTRW.pdf',
        },
        'product-single-401': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-402': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-403': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-404': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-405': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-406': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-407': {
                'ipid_title': 'Battleface IPID',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/battleface-IPID.pdf',
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface-policy-eea_eur.pdf',
        },
        'product-single-408': {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface_global_direct_travel_plan.pdf',
        },
        'product-single-409': {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface_global_direct_travel_plan.pdf',
        },
        'product-single-410': {
                'pwo_title':'Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/battleface_global_direct_travel_plan.pdf',
        },
        'product-single-300' : {
                'tob_title': 'Schedule of Coverage (Basic)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Basic).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Basic)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Basic).pdf'
        },
        'product-single-301' : {
                'tob_title': 'Schedule of Coverage (Extended)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Extended).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Extended)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Extended).pdf'
        },
        'product-single-302' : {
                'tob_title': 'Schedule of Coverage (Extended incl. Winter Sports)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Extended_incl._Winter_Sports).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Extended incl. Winter Sports)',
        'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Extended_incl._Winter_Sports).pdf'
        },
        'product-single-303' : {
                'tob_title': 'Schedule of Coverage (Luxury)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Luxury).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Luxury)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Luxury).pdf'
        },
        'product-single-304' : {
                'tob_title': 'Schedule of Coverage (Luxury incl. Winter Sports)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Luxury_incl._Winter_Sports).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Luxury incl. Winter Sports)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Luxury_incl._Winter_Sports).pdf'
        },
        'product-single-305' : {
                'tob_title': 'Schedule of Coverage (Business Extended)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Business_Extended).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Business Extended)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Business_Extended).pdf'
        },
        'product-single-306' : {
                'tob_title': 'Schedule of Coverage (Business Basic)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Business_Basic).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Business Basic)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Business_Basic).pdf'
        },
        'product-single-307' : {
                'tob_title': 'Schedule of Coverage (Travel Agent Leisure)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Travel_Agent_Leisure).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Travel Agent Leisure)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Travel_Agent_Leisure).pdf'
        },
        'product-single-308' : {
                'tob_title': 'Schedule of Coverage (Summer By Lets Go)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Summer_Lets_Go).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Summer By Lets Go)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Summer_Lets_Go).pdf'
        },
        'product-annual-301' : {
                'tob_title': 'Schedule of Coverage (AMT Basic)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(AMT_Basic).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (AMT Basic)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(AMT_Basic).pdf'
        },
        'product-annual-302' : {
                'tob_title': 'Schedule of Coverage (AMT Extended)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(AMT_Extended).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (AMT Extended)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(AMT_Extended).pdf'
        },
        'product-annual-303' : {
                'tob_title': 'Schedule of Coverage (AMT Basic incl. Winter Sports)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(AMT_Basic_incl._Winter_Sports).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (AMT Basic incl. Winter Sports)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(AMT_Basic_incl._Winter_Sports).pdf'
        },
        'product-annual-304' : {
                'tob_title': 'Schedule of Coverage (AMT Extended incl. Winter Sports)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(AMT_Extended_incl._Winter_Sports).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (AMT Extended incl. Winter Sports)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(AMT_Extended_incl._Winter_Sports).pdf'
        },
        'product-annual-305' : {
                'tob_title': 'Schedule of Coverage (AMT Business Basic)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(AMT_Business_Basic).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (AMT Business Basic)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(AMT_Business_Basic).pdf'
        },
        'product-longstay-301' : {
                'tob_title': 'Schedule of Coverage (Study)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Study).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'ipid_title': 'IPID (Study)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Study).pdf'
        },
        'product-longstay-302' : {
                'tob_title': 'Schedule of Coverage (Study Extended)',
                'tob_link': 'https://quote.safetravel.today/files/schedules/SFT_-_Schedule_of_Coverage_(Study_Extended).pdf',
                'pwo_title':'SFT Policy Wording',
                'pwo_link':'https://quote.safetravel.today/files/pwo/SFT_-_Policy_Wording.pdf',
                'pwo_link_addition':'https://quote.safetravel.today/files/pwo/SFT_-_Endorsement_-_Third-Party_Liability_Coverage_(for_Study_Extended).pdf',
                'ipid_title': 'IPID (Study Extended)',
                'ipid_link': 'https://quote.safetravel.today/files/ipid/SFT_-_IPID_and_Schedule_of_Coverage_(Study_Extended).pdf'
        }
}

export const euCountries = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Czech Republic', 'Denmark','Ireland', 'Estonia','Finland', 'France', 'Germany', 'Greece','Hungary', 'Isle of Man', 'Israel', 'Italy', 'Latvia', 'Lithuania','Luxembourg', 'Netherlands', 'Norway', 'Poland', 'Portugal', 'Romania','Slovakia', 'Slovenia', 'Spain', 'Sweden', 'United Kingdom','Falkland Islands', 'Gibraltar', 'Malta', 'Guernsey', 'Jersey', 'Cyprus','Andorra', 'Switzerland', 'Liechtenstein', 'Monaco', 'San Marino', 'Vatican City'];


export const viewsProductsMixin = {
        methods: {
                setImg() {
                        // Validate product_code
                        if (typeof this.product_code !== 'string' || !this.product_code) {
                                this.product_img = this.sompo_img || '';
                                return;
                        }

                        // Define prefix-to-image mapping
                        const imageMap = {
                                'product-single-9': this.col_img,
                                'product-longstay-9': this.col_img,
                                'product-annual-9': this.col_img,
                                'product-single-6': this.mon_img,
                                'product-longstay-6': this.mon_img,
                                'product-annual-6': this.mon_img,
                                'product-single-3': this.sompo_img,
                                'product-longstay-3': this.sompo_img,
                                'product-annual-3': this.sompo_img,
                                'product-single-8': this.kem_img,
                                'product-longstay-8': this.kem_img,
                                'product-annual-8': this.kem_img,
                                'product-single-4': this.battle_img,
                                'product-longstay-4': this.battle_img,
                                'product-annual-4': this.battle_img
                        };

                        // Find matching prefix
                        const matchingPrefix = Object.keys(imageMap).find(prefix => this.product_code.startsWith(prefix));

                        // Set image or default
                        if (matchingPrefix && imageMap[matchingPrefix]) {
                                this.product_img = imageMap[matchingPrefix];
                        } else {
                                console.warn(`No image mapping for product_code: ${this.product_code}`);
                                this.product_img = this.sompo_img || '';
                        }
                },
                storageOfferName() {
                        const temporaryDictionary={}
                        const values = [].filter.call(document.getElementsByName('products_arr[]'), (c) => c.checked).map(c => {
                                temporaryDictionary[c.value] = c.getAttribute('data-price') 
                        });
                        localStorage.setItem('checkedProducts', JSON.stringify(temporaryDictionary));
                },
                zeroProducts() {
                        const zeroValues = [0, '0', 2, '2', null, undefined];
                        const flatAges = Array.isArray(this.agesArr)
                        ? [...this.agesArr].flat().map(Number).filter(n => !isNaN(n))
                        : [];

                        // Hardcoded for now; ideally, fetch from backend or config
                        const ageThresholds = {
                                "product-single-6400": 75,
                                "product-single-6403": 75,
                                "product-single-6535": 75,
                                "product-single-6419": 70,
                                "product-single-6418": 75,
                                "product-single-6421": 75,
                                "product-single-401": 79,
                                "product-single-402": 79,
                                "product-single-403": 79,
                                "product-single-404": 79,
                                "product-single-405": 79,
                                "product-single-406": 79,
                                "product-single-407": 79,
                                "product-single-408": 79,
                                "product-single-409": 79,
                                "product-single-410": 79,
                                "product-single-900": 80,
                                "product-single-911": 85,
                                "product-single-913": 70,
                                "product-single-916": 80,
                                "product-longstay-901": 75,
                                "product-longstay-902": 55,
                                "product-annual-901": 85,
                                "product-annual-902": 85,
                                "product-single-918": 64,
                                "product-single-300": 86,
                                "product-single-301": 86,
                                "product-single-302": 65,
                                "product-single-303": 86,
                                "product-single-304": 65,
                                "product-single-305": 70,
                                "product-single-306": 70,
                                "product-single-307": 86,
                                "product-single-308": 86,
                                "product-annual-301": 80,
                                "product-annual-302": 80,
                                "product-annual-303": 80,
                                "product-annual-304": 80,
                                "product-annual-305": 80,
                                "product-longstay-301": 45,
                                "product-longstay-302": 45
                        };
                        this.zeropricebtnReason = '';
                        // Validate product_code
                        if (typeof this.product_code !== 'string' || !this.product_code) {
                                this.zeroproductimg = 'zeroproductimg';
                                this.backgroundtransparent = 'backgroundTransparent';
                                this.zeropricebtn = true;
                                this.zeropricebtnReason = 'Invalid product code';
                                return;
                        }
                        // Get maxAge
                        const maxAge = ageThresholds[this.product_code] ?? 95;
                        const ageExceeded = flatAges.some(age => age > maxAge);
                        const isZeroPrice = zeroValues.includes(this.product_price);

                        if (isZeroPrice || ageExceeded) {
                                this.zeroproductimg = 'zeroproductimg';
                                this.backgroundtransparent = 'backgroundTransparent';
                                this.zeropricebtn = true;
                                if (ageExceeded) {
                                        this.zeropricebtnReason = `One or more travelers are over the maximum age of ${maxAge} for this product`;
                                } else if (isZeroPrice) {
                                        this.zeropricebtnReason = `This product is not available`;
                                };
                        }
                },
                checkProducts(selector) {
                        // Define product IDs
                        const productIds = [
                                '900', '905', '907', '908', '909', '910', '912', '913', '915', '916',
                                '917', '918', '919', '807', '808', '809', '810', '811', '812', '401',
                                '402', '403', '404', '405', '406', '407', '408', '409', '410', '300',
                                '301', '302', '303', '304', '305', '306', '307', '308'
                        ];

                        // Define EU and related countries
                        const euCountries = [
                                'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Czech Republic', 'Denmark',
                                'Ireland', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
                                'Hungary', 'Isle of Man', 'Israel', 'Italy', 'Latvia', 'Lithuania',
                                'Luxembourg', 'Netherlands', 'Norway', 'Poland', 'Portugal', 'Romania',
                                'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'United Kingdom',
                                'Falkland Islands', 'Gibraltar', 'Malta', 'Guernsey', 'Jersey', 'Cyprus',
                                'Andorra', 'Switzerland', 'Liechtenstein', 'Monaco', 'San Marino', 'Vatican City'
                        ];

                        // Query all single products and specific annual/longstay for IDs 301, 302
                        const products = Object.fromEntries(
                                productIds.flatMap(id => {
                                const entries = [[`product_single_${id}`, document.querySelector(`${selector}product-single-${id}`) ?? null]];
                                if (['301', '302'].includes(id)) {
                                entries.push(
                                [`product_annual_${id}`, document.querySelector(`${selector}product-annual-${id}`) ?? null],
                                [`product_longstay_${id}`, document.querySelector(`${selector}product-longstay-${id}`) ?? null]
                                );
                                }
                                return entries;
                                })
                        );

                        // Configuration for product removals
                        const removalRules = [
                                {
                                condition: () => true, // Always remove mundial products
                                products: [
                                { id: '6', types: ['single', 'annual', 'longstay'], match: 'startsWith' }
                                ]
                                },
                                {
                                condition: () => true,
                                products: [
                                { id: '905', types: ['single'] },
                                { id: '907', types: ['single'] },
                                { id: '913', types: ['single'] }, // Visit Greece
                                { id: '408', types: ['single'] }, // Crum & Foster
                                { id: '409', types: ['single'] },
                                { id: '410', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => this.resCheckName !== 'Cyprus',
                                products: [
                                { id: '917', types: ['single'] },
                                { id: '918', types: ['single'] },
                                { id: '919', types: ['single'] },
                                { id: '913', types: ['single'] },
                                { id: '308', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => !euCountries.includes(this.resCheckName),
                                products: [
                                { id: '300', types: ['single'] },
                                { id: '301', types: ['single', 'annual', 'longstay'] },
                                { id: '302', types: ['single', 'annual', 'longstay'] },
                                { id: '303', types: ['single'] },
                                { id: '304', types: ['single'] },
                                { id: '305', types: ['single'] },
                                { id: '306', types: ['single'] },
                                { id: '307', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => ['Cuba', 'Nigeria', 'Israel'].includes(this.destCheckName),
                                products: [
                                { id: '300', types: ['single', 'annual', 'longstay'] },
                                { id: '301', types: ['single', 'annual', 'longstay'] },
                                { id: '302', types: ['single', 'annual', 'longstay'] },
                                { id: '303', types: ['single'] },
                                { id: '304', types: ['single'] },
                                { id: '305', types: ['single'] },
                                { id: '306', types: ['single'] },
                                { id: '307', types: ['single'] },
                                { id: '308', types: ['single'] },
                                { id: '309', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => {
                                try {
                                return moment(this.startDate, 'DD/MM/YYYY').diff(moment(new Date(), 'DD/MM/YYYY'), 'days') < 1;
                                } catch (e) {
                                console.warn(e);
                                return false;
                                }
                                },
                                products: [
                                { id: '917', types: ['single'] },
                                { id: '918', types: ['single'] },
                                { id: '919', types: ['single'] },
                                { id: '913', types: ['single'] },
                                { id: '915', types: ['single'] },
                                { id: '920', types: ['single'] },
                                { id: '308', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => this.daysNum < 5,
                                products: [{ id: '918', types: ['single'] }, { id: '308', types: ['single'] }]
                                },
                                {
                                condition: () => this.daysNum > 8,
                                products: [
                                { id: '918', types: ['single'] },
                                { id: '913', types: ['single'] },
                                { id: '915', types: ['single'] },
                                { id: '920', types: ['single'] },
                                { id: '308', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => this.daysNum > 15,
                                products: [{ id: '917', types: ['single'] }]
                                },
                                {
                                condition: () => this.daysNum > 12,
                                products: [{ id: '919', types: ['single'] }]
                                },
                                {
                                condition: () => this.daysNum > 31,
                                products: [
                                { id: '908', types: ['single'] },
                                { id: '909', types: ['single'] },
                                { id: '910', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => this.resCheckName !== 'Greece',
                                products: [
                                { id: '912', types: ['single'] },
                                { id: '915', types: ['single'] },
                                { id: '920', types: ['single'] }
                                ]
                                },
                                {
                                condition: () => this.destCheckName !== 'Greece',
                                products: [{ id: '913', types: ['single'] }]
                                },
                                {
                                condition: () => this.resCheckName !== 'Greece' || this.destCheckName !== 'Greece',
                                products: [{ id: '916', types: ['single'] }]
                                },
                                {
                                condition: () => this.destCheckName === 'Iran',
                                products: [
                                { id: '807', types: ['single'] },
                                { id: '808', types: ['single'] },
                                { id: '809', types: ['single'] },
                                { id: '810', types: ['single'] },
                                { id: '811', types: ['single'] },
                                { id: '812', types: ['single'] }
                                ]
                                }
                        ];

                        // Helper function to remove products
                        const removeProducts = (rule) => {
                                if (rule.condition()) {
                                rule.products.forEach(product => {
                                if (product.match === 'startsWith') {
                                document.querySelectorAll(
                                        product.types.map(type => `[id^="product-${type}-${product.id}"]`).join(', ')
                                ).forEach(element => element.remove());
                                } else {
                                product.types.forEach(type => {
                                        const key = `product_${type}_${product.id}`;
                                        const element = products[key] || document.querySelector(`${selector}product-${type}-${product.id}`);
                                        element?.remove();
                                });
                                }
                                });
                                }
                        };

                        // Apply all removal rules
                        removalRules.forEach(removeProducts);
                },
                async onProductSelect(product_code) {
                if (this.loadingAddons) return;   // block double click
                this.loadingAddons = true;
                try {
                        // Load add-ons
                        const data_s = {
                        token: "1dbaa403b94ccdd1991c3afd511858a5",
                        product: product_code
                        }

                        const response = await fetch('https://api-quote.safetravel.today/v2/app/get_product_addons_app', {
                        method: 'post',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(data_s)
                        })
                        if (!response.ok) throw new Error(`Get product addons HTTP error: ${response.status}`);
                        const data = await response.json();

                        if (data.error) {
                        console.error('Error fetching add-ons:', data.error);
                        return;
                        }

                        this.productAddOns = data;

                        // If selections exist for this product, keep them
                        if (!this.selectedOptionsPerProduct[product_code]) {
                        // Initialize empty arrays for each category
                        const options = {};
                        this.productAddOns.forEach(a => {
                                if (!options[a.category]) options[a.category] = [];
                        });
                        this.$set(this.selectedOptionsPerProduct, product_code, options);
                        }

                        // Set reactive selectedOptions for modal binding
                        this.selectedOptions = this.selectedOptionsPerProduct[product_code];

                        this.calculateTotalPrice(product_code);

                        // Show modal
                        this.$nextTick(() => {
                        this.$refs['optionModal_' + product_code].show();
                        });

                } catch (err) {
                        console.error('Failed to fetch product add-ons:', err);
                } finally {
                        this.loadingAddons = false;
                }
                },
                calculateTotalPrice(product_code) {
                const basePrice = Number(this.product_price) || 0;
                
                const formattedAddOns = [];
                let addon_addend = 0;
                let addon_multiplier = 1;

                for (const category of this.getCategoryDetails()) {
                        const selectedIds = this.selectedOptions[category.key] || [];
                        if (!selectedIds.length) continue;

                        const options = this.productAddOns.filter(a => a.category === category.key);

                        selectedIds.forEach(id => {
                        const matched = options.find(opt => opt.id == id);
                        if (matched) {
                                formattedAddOns.push({
                                id: Number(matched.id),
                                name: matched.name,
                                category: category.key,
                                value: matched.value
                                });

                                //  addons with action='addend'
                                if (matched.action === 'addend') {
                                addon_addend += Number(matched.value) || 0;
                                } else if (matched.action === 'multiplier') {
                                addon_multiplier *= Number(category.multiplier) || 1;
                                } else {
                                // Fallback: if no action, use category multiplier
                                addon_multiplier *= Number(category.multiplier) || 1;
                                }
                        }
                        });
                }

                let total = (basePrice + addon_addend) * addon_multiplier;
                this.totalPrice = Number(total.toFixed(2));
                this.$set(this.selectedOptionsPerProduct, product_code, this.selectedOptions);
                this.$emit('update-initial-request', {
                        totalPrice: this.totalPrice,
                        selectedOptions: formattedAddOns
                });
                },
                getCategoryDetails() {
                        return [
                                { 
                                        key: 'category_1',
                                        multiplier: 1,
                                        header:'All activities listed below are covered as standard risks within the scope of all policies/plans subject to the terms,conditions and exclusions stated in this Policy. Please note that restrictions apply to activities marked with one or more asterisks. Activities marked with one asterisk (<span style="color:red">*</span>) are not covered under Section G (“Personal Liability”). Activities marked with two asterisks (<span style="color:red">**</span>) are not covered under Section C (“Personal Accident”). Certain restrictions may apply to some individual sports and activities as stated in brackets below.',
                                        text:'Activities marked with one asterisk (<span style="color:red">*</span>) are not covered under Section G (“Personal Liability”). Activities marked with two asterisks (<span style="color:red">**</span>) are not covered under Section C (“Personal Accident”).'
                                },
                                { 
                                        key: 'category_2',
                                        multiplier: 2,
                                        header:'All activities listed below are covered under this insurance Policy if the Policyholder has paid the appropriate additional premium (x2 the standard price), and this has been noted on the Validation Certificate, subject to the terms, conditions and exclusions stated in this Policy. Please note that all sports and activities in this category are not covered under Section C (“Personal Accident”) and Section G (“Personal Liability”). Certain restrictions may apply to some individual sports and activities as stated in brackets below.',
                                        text:'No coverage under Section C (“Personal Accident”) and Section G (“Personal Liability”).'
                                },
                                { 
                                        key: 'category_3',
                                        multiplier: 2.5,
                                        header:'All activities listed below are covered under this insurance Policy if the Policyholder has paid the appropriate additional premium (x2,5 the standard price), and this has been noted on the Validation Certificate, subject to the terms, conditions and exclusions stated in this Policy. Please note that all sports and activities in this category are not covered under Section C (“Personal Accident”) and Section G (“Personal Liability”). Certain restrictions may apply to some individual sports and activities as stated in brackets below.',
                                        text:'No coverage under Section C (“Personal Accident”) and Section G (“Personal Liability”).'
                                },
                                { 
                                        key: 'category_4',
                                        multiplier: 2.75,
                                        header:'All activities listed below are covered under this insurance Policy if the Policyholder has paid the appropriate additional premium (x2,75 the standard price), and this has been noted on the Validation Certificate, subject to the terms, conditions and exclusions stated in this Policy. Please note that all sports and activities in this category are not covered under Section C (“Personal Accident”) and Section G (“Personal Liability”). Moreover, all sports and activities in this category must be carried out within organiser’s guidelines and will only be covered as part of a pre-arranged/organised activity led or instructed by professional guides or organisers. Certain restrictions may apply to some individual sports and activities as stated in brackets below.',
                                        text:'No coverage under Section C (“Personal Accident”) and Section G (“Personal Liability”).'
                                },
                        ]
                }
        },
        computed: {
                bestValueProducts() {
                  return ['product-single-300', 'product-single-306', 'product-annual-301', 'product-longstay-301', 'product-single-307', 'product-annual-303', 'product-single-308', 'product-annual-305'];
                },
                mostPopularProducts() {
                  return ['product-single-301', 'product-single-302', 'product-single-305', 'product-annual-302', 'product-longstay-302', 'product-annual-304'];
                },
                fullProtectionProducts() {
                  return ['product-single-303','product-single-304'];
                },
                hasSecondaryCoverage() {
                  // Validate product_code
                  if (typeof this.product_code !== 'string' || !this.product_code) {
                    return false;
                  }
                  return !(
                    this.product_code.startsWith('product-single-3') ||
                    this.product_code.startsWith('product-longstay-3') ||
                    this.product_code.startsWith('product-annual-3')
                  );
                },
                isSompoProduct() {
                 return (
                  this.product_code.startsWith('product-single-3') ||
                  this.product_code.startsWith('product-longstay-3') ||
                  this.product_code.startsWith('product-annual-3')
                 );
                }
        }
}

export const agentsMixin = {
  data() {
    return {
      logoba: require('@/assets/images/quotation/best_advice_logo.png'),
      logoinsline: require('@/assets/images/quotation/insuranceline.jpg'),
      logoamathus: require('@/assets/images/quotation/amathus.png'),
      logotravelsafe: require('@/assets/images/quotation/logotravelsafe.jpg'),
      logogerofotis: require('@/assets/images/quotation/logogerofotis.png'),
      logoletsgo: require('@/assets/images/quotation/logoletsgo.png'),
    }
  },
  computed: {
    // Mapping configuration for each agent
    agentConfig() {
      return {
        'fffb2865f89a3cf311000ce9c5d05aa9': {
          logo: 'logoba',
          link: 'https://www.bainsurance.gr/',
          logoTxt: 'Agent:',
          colors: {}
        },
        '778df1a7b580dda570aa786977119102': {
          logo: 'logoinsline',
          link: 'https://www.insuranceline.gr/',
          logoTxt: 'Powered by:',
          colors: {
            '--accent1-color': '#3a3a3a',
            '--accent2-color': '#f0483e',
            '--accent3-color': '#555555',
            '--bg-color': '#F5F5F5',
            '--foreground-color': '#424242',
            '--primary-color': '#f0483e',
            '--success-color': '#3a3a3a',
            '--danger-color': '#f0483e',
            '--secondary-color': '#f0483e',
            '--successlight-color': 'rgba(58, 58, 58, 0.12)',
            '--dangerlight-color': 'rgba(240, 72, 62, 0.12)',
            '--foreground-color-rgb': '66, 66, 66',
            '--primary-color-rgb': '240, 72, 62',
            '--bg-color-rgb': '245, 245, 245',
            '--underline-color': '#fff',
            '--accent1-color-rgb': '58, 58, 58'
          }
        },
        'a10a56720f363e1aaf1070d04406e8e5': {
          logo: 'logoamathus',
          link: 'https://amathus.com/',
          logoTxt: 'Powered by:',
          colors: {
            '--accent1-color': '#01447b',
            '--accent2-color': '#00447c',
            '--accent3-color': '#00447c',
            '--bg-color': '#fff',
            '--foreground-color': '#2d2d2d',
            '--primary-color': '#00447c',
            '--success-color': '#01447b',
            '--danger-color': '#ea5455',
            '--secondary-color': '#00447c',
            '--successlight-color': 'rgba(58, 58, 58, 0.12)',
            '--dangerlight-color': 'rgba(240, 72, 62, 0.12)',
            '--foreground-color-rgb': '45, 45, 45',
            '--primary-color-rgb': '0, 68, 124',
            '--bg-color-rgb': '245, 245, 245',
            '--underline-color': '#fff',
            '--accent1-color-rgb': '1, 68, 123'
          }
        },
        '84c73d854cfce517f71be74b595ace0z': {
          logo: 'logoamathus',
          link: 'https://amathus.com/',
          logoTxt: 'Powered by:',
          colors: {
            '--accent1-color': '#01447b',
            '--accent2-color': '#00447c',
            '--accent3-color': '#00447c',
            '--bg-color': '#fff',
            '--foreground-color': '#2d2d2d',
            '--primary-color': '#00447c',
            '--success-color': '#01447b',
            '--danger-color': '#ea5455',
            '--secondary-color': '#00447c',
            '--successlight-color': 'rgba(58, 58, 58, 0.12)',
            '--dangerlight-color': 'rgba(240, 72, 62, 0.12)',
            '--foreground-color-rgb': '45, 45, 45',
            '--primary-color-rgb': '0, 68, 124',
            '--bg-color-rgb': '245, 245, 245',
            '--underline-color': '#fff',
            '--accent1-color-rgb': '1, 68, 123'
          }
        },
        'ce33bf77aec27593e71978fda43b4fc2': {
        logo: 'logoletsgo',
        link: 'https://letsgotours.com/',
        logoTxt: 'Powered by:',
        colors: {
        '--accent1-color': '#f25a2b',
        '--accent2-color': '#106BDA',
        '--accent3-color': '#db5229',
        '--bg-color': '#f4f5f7',
        '--foreground-color': '#2d3033',
        '--primary-color': '#f25a2b',
        '--success-color': '#db5229',
        '--danger-color': '#CE3426',
        '--secondary-color': '#003149',
        '--successlight-color': 'rgba(39, 169, 116, 0.12)',
        '--dangerlight-color': 'rgba(206, 52, 38, 0.12)',
        '--foreground-color-rgb': '45, 48, 51',
        '--primary-color-rgb': '242, 90, 43',
        '--bg-color-rgb': '244, 245, 247',
        '--underline-color': '#fff',
        '--accent1-color-rgb': '242, 90, 43'
        }
        },
        'f5d68dc1f2abb1d21853d530907e2da1': {
          logo: 'logotravelsafe',
          link: 'https://travelsafe.gr/',
          logoTxt: 'Powered by:',
          colors: {
            '--accent1-color': '#212529',
            '--accent2-color': '#5d3997',
            '--accent3-color': 'rgba(33, 37, 41, 0.75)',
            '--bg-color': '#fff',
            '--foreground-color': '#2d2d2d',
            '--primary-color': 'rgba(33, 37, 41, 0.75)',
            '--success-color': '#198754',
            '--danger-color': '#dc3545',
            '--secondary-color': 'rgba(33, 37, 41, 0.75)',
            '--successlight-color': 'rgba(86, 148, 149, 0.12)',
            '--dangerlight-color': '#58151c',
            '--foreground-color-rgb': '45, 45, 45',
            '--primary-color-rgb': '33, 37, 41',
            '--bg-color-rgb': '245, 245, 245',
            '--underline-color': '#fff',
            '--accent1-color-rgb': '33, 37, 41'
          }
        },
        'd2027444d920cc8ad876cf529cf7c993': {
          logo: 'logogerofotis',
          link: 'https://gerofotistravel.gr/',
          logoTxt: 'Powered by:',
          colors: {}
        }
      }
    },

    // Get current agent config
    currentAgent() {
      return this.agentConfig[store.state.agent] || null
    },

    // Agent link
    linkAgent() {
      return this.currentAgent?.link || null
    },

    // Landing link
    linkLanding() {
      return store.state.agent !== '1dbaa403b94ccdd1991c3afd511858a5'
        ? { name: 'landing', query: { agent: store.state.agent } }
        : { name: 'landing' }
    },

    // Whether to show agent branding
    showAgent() {
      if (!this.currentAgent) return false

      // Apply custom colors if any
      if (this.currentAgent.colors) {
        const root = document.documentElement
        Object.entries(this.currentAgent.colors).forEach(([key, value]) => {
          root.style.setProperty(key, value)
        })
      }

      return true
    },
    // Logo text
    logoTxt() {
      return this.currentAgent?.logoTxt || 'Agent:'
    },
    // Agent logos
    agentLogoFunc() {
      return this[this.currentAgent?.logo] || ''
    },
    agentLogoMobileFunc() {
      return this[this.currentAgent?.logo] || ''
    },
  }
}

// form submit
export const formSubmitMixin = {
  data() {
    return {
      isSubmitting: false,
      formModal: false,
      formStatus: null,
    }
  },
  methods: {
        validateForm() {
                for (const [key, value] of Object.entries(this.formData)) {
                        if (!value || !value.toString().trim()) {
                        return { valid: false, error: `${key} is required` }
                        }
                }

                // email validation — works for both contact (email) and affiliate (company_email)
                const emailField = this.formData.email || this.formData.company_email
                if (emailField && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField)) {
                        return { valid: false, error: 'Invalid email format' }
                }

                // phone validation — works for both phone and company_phone
                const phoneField = this.formData.phone || this.formData.company_phone
                if (phoneField && !/^[+0-9]{6,}$/.test(phoneField)) {
                        return { valid: false, error: 'Invalid phone number' }
                }

                return { valid: true }
        },
        async submitForm(type) {
                const { valid, error } = this.validateForm()
                if (!valid) {
                        this.formStatus = 'error'
                        this.formModal = true
                        console.warn('Validation error:', error)
                        return
                }

                this.isSubmitting = true
                // check grecaptcha is loaded
                if (typeof grecaptcha === 'undefined') {
                        this.formStatus = 'error'
                        this.formModal = true
                        this.isSubmitting = false
                        return
                }
                try {
                        // get recaptcha token
                        const recaptchaToken = await new Promise((resolve) => {
                                grecaptcha.ready(async () => {
                                const token = await grecaptcha.execute(
                                '6LfAFoEsAAAAAEWP8F9gJ5-fK5SJ2brnRLd7dfTQ',
                                { action: type }
                                )
                                resolve(token)
                                })
                        })
                        // email
                        const response = await fetch('https://api-quote.safetravel.today/v2/app/contact_email', {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                        },
                        body: JSON.stringify({ ...this.formData, type, recaptchaToken, token: '1dbaa403b94ccdd1991c3afd511858a5' })
                        })

                        if (response.status === 429) {
                        this.formStatus = 'ratelimit'
                        this.formModal = true
                        this.isSubmitting = false
                        return
                        }
                        if (response.status === 403) {
                        this.formStatus = 'recaptcha_failed'
                        this.formModal = true
                        this.isSubmitting = false
                        return
                        }
                        if (!response.ok) throw new Error(`Form submit HTTP error ${response.status}`)

                        const data = await response.json()
                        if (data.success) {
                        Object.keys(this.formData).forEach(key => this.formData[key] = '')
                        this.formStatus = 'success'
                        } else {
                        this.formStatus = 'error'
                }
                } catch (error) {
                        console.warn(error)
                        this.formStatus = 'error'
                } finally {
                        this.isSubmitting = false
                        this.formModal = true
                }
        }
  },
  computed: {
    modalTitle() {
        const titles = {
            success: '✅ Message Sent',
            ratelimit: '⏳ Slow Down',
            recaptcha_failed: '🤖 Verification Failed',
            error: '❌ Something Went Wrong'
        }
        return titles[this.formStatus] || 'Notice'
    }
  }
}

export const countrysFrom = [
        { value: '1', text: 'Alaska', id:'1' },
        { value: '15', text: 'Albania', id:'15' },
        { value: '3', text: 'Algeria', id:'3' },
        { value: '284', text: 'Andorra', id:'284' },
        { value: '30', text: 'Angola', id:'30' },
        { value: '35', text: 'Anguilla', id:'35' },
        { value: '40', text: 'Antarctica', id:'40' },
        { value: '45', text: 'Antigua', id:'45' },
        { value: '1043', text: 'Antilles', id:'1043' },
        { value: '50', text: 'Argentina', id:'50' },
        { value: '7', text: 'Armenia', id:'7' },
        { value: '8', text: 'Aruba', id:'8' },
        { value: '65', text: 'Ascension Island', id:'65' },
        { value: '9', text: 'Australia', id:'9' },
        { value: '4', text: 'Austria', id:'4' },
        { value: '80', text: 'Azerbaijan', id:'80' },
        { value: '90', text: 'Bahamas', id:'90' },
        { value: '95', text: 'Bahrain', id:'95' },
        { value: '100', text: 'Bali', id:'100' },
        { value: '105', text: 'Bangladesh', id:'105' },
        { value: '110', text: 'Barbados', id:'110' },
        { value: '115', text: 'Barbuda', id:'115' },
        { value: '1045', text: 'Belarus', id:'1045' },
        { value: '6', text: 'Belgium', id:'6' },
        { value: '130', text: 'Belize', id:'130' },
        { value: '135', text: 'Benin', id:'135' },
        { value: '140', text: 'Bermuda', id:'140' },
        { value: '145', text: 'Bhutan', id:'145' },
        { value: '150', text: 'Bolivia', id:'150' },
        { value: '1044', text: 'Bosnia and Herzegovina', id:'1044' },
        { value: '160', text: 'Botswana', id:'160' },
        { value: '165', text: 'Brazil', id:'165' },
        { value: '170', text: 'Brunei', id:'170' },
        { value: '10', text: 'Bulgaria', id:'10' },
        { value: '180', text: 'Burkina Faso', id:'180' },
        { value: '190', text: 'Burundi', id:'190' },
        { value: '195', text: 'Cambodia', id:'195' },
        { value: '200', text: 'Cameroon', id:'200' },
        { value: '205', text: 'Canada', id:'205' },
        { value: '215', text: 'Cape Verde', id:'215' },
        { value: '220', text: 'Cayman Islands', id:'220' },
        { value: '230', text: 'Chad', id:'230' },
        { value: '240', text: 'Chile', id:'240' },
        { value: '245', text: 'China', id:'245' },
        { value: '250', text: 'Colombia', id:'250' },
        { value: '255', text: 'Comoros', id:'255' },
        { value: '265', text: 'Cook Islands', id:'265' },
        { value: '270', text: 'Costa Rica', id:'270' },
        { value: '14', text: 'Croatia', id:'14' },
        { value: '1047', text: 'Cuba', id:'1047' },
        { value: '283', text: 'Cyprus', id:'283' },
        { value: '16', text: 'Czech Republic', id:'16' },
        { value: '17', text: 'Denmark', id:'17' },
        { value: '305', text: 'Djibouti', id:'305' },
        { value: '310', text: 'Dominica', id:'310' },
        { value: '315', text: 'Dominican Republic', id:'315' },
        { value: '320', text: 'Ecuador', id:'320' },
        { value: '325', text: 'Egypt', id:'325' },
        { value: '335', text: 'El Salvador', id:'335' },
        { value: '340', text: 'Equatorial Guinea', id:'340' },
        { value: '345', text: 'Eritrea', id:'345' },
        { value: '20', text: 'Estonia', id:'20' },
        { value: '355', text: 'Ethiopia', id:'355' },
        { value: '87', text: 'Falkland Islands', id:'87' },
        { value: '1048', text: 'Faroe Islands', id:'1048' },
        { value: '365', text: 'Fiji', id:'365' },
        { value: '21', text: 'Finland', id:'21' },
        { value: '22', text: 'France', id:'22' },
        { value: '1050', text: 'French Guiana', id:'1050' },
        { value: '1066', text: 'French Polynesia', id:'1066' },
        { value: '380', text: 'Gabon', id:'380' },
        { value: '385', text: 'Gambia', id:'385' },
        { value: '390', text: 'Georgia', id:'390' },
        { value: '23', text: 'Germany', id:'23' },
        { value: '400', text: 'Ghana', id:'400' },
        { value: '89', text: 'Gibraltar', id:'89' },
        { value: '24', text: 'Greece', id:'24' },
        { value: '415', text: 'Greenland', id:'415' },
        { value: '420', text: 'Grenada', id:'420' },
        { value: '1049', text: 'Guadeloupe', id:'1049' },
        { value: '425', text: 'Guam', id:'425' },
        { value: '430', text: 'Guatemala', id:'430' },
        { value: '174', text: 'Guernsey', id:'174' },
        { value: '440', text: 'Guinea', id:'440' },
        { value: '450', text: 'Guinea-Bissau', id:'450' },
        { value: '455', text: 'Guyana', id:'455' },
        { value: '460', text: 'Haiti', id:'460' },
        { value: '470', text: 'Honduras', id:'470' },
        { value: '475', text: 'Hong Kong', id:'475' },
        { value: '27', text: 'Hungary', id:'27' },
        { value: '1052', text: 'Iceland', id:'1052' },
        { value: '490', text: 'India', id:'490' },
        { value: '495', text: 'Indonesia', id:'495' },
        { value: '1051', text: 'Iran', id:'1051' },
        { value: '31', text: 'Isle of Man', id:'31' },
        { value: '32', text: 'Israel', id:'32' },
        { value: '33', text: 'Italy', id:'33' },
        { value: '530', text: 'Côte d’Ivoire', id:'530' },
        { value: '535', text: 'Jamaica', id:'535' },
        { value: '540', text: 'Japan', id:'540' },
        { value: '186', text: 'Jersey', id:'186' },
        { value: '550', text: 'Jordan', id:'550' },
        { value: '1053', text: 'Kazakhstan', id:'1053' },
        { value: '555', text: 'Kenya', id:'555' },
        { value: '560', text: 'Kiribati', id:'560' },
        { value: '575', text: 'South Korea', id:'575' },
        { value: '1067', text: 'Kosovo', id:'1067' },
        { value: '580', text: 'Kuwait', id:'580' },
        { value: '1054', text: 'Kyrgyzstan', id:'1054' },
        { value: '585', text: 'Laos', id:'585' },
        { value: '38', text: 'Latvia', id:'38' },
        { value: '595', text: 'Lebanon', id:'595' },
        { value: '600', text: 'Lesotho', id:'600' },
        { value: '605', text: 'Liberia', id:'605' },
        { value: '1055', text: 'Libya', id:'1055' },
        { value: '288', text: 'Liechtenstein', id:'288' },
        { value: '41', text: 'Lithuania', id:'41' },
        { value: '42', text: 'Luxembourg', id:'42' },
        { value: '1056', text: 'Macao', id:'1056' },
        { value: '635', text: 'Madagascar', id:'635' },
        { value: '645', text: 'Malawi', id:'645' },
        { value: '650', text: 'Malaysia', id:'650' },
        { value: '655', text: 'Maldives', id:'655' },
        { value: '1059', text: 'Mali', id:'1059' },
        { value: '93', text: 'Malta', id:'93' },
        { value: '1062', text: 'Martinique', id:'1062' },
        { value: '665', text: 'Mauritania', id:'665' },
        { value: '670', text: 'Mauritius', id:'670' },
        { value: '675', text: 'Mexico', id:'675' },
        { value: '680', text: 'Moldova', id:'680' },
        { value: '289', text: 'Monaco', id:'289' },
        { value: '690', text: 'Mongolia', id:'690' },
        { value: '1061', text: 'Montenegro', id:'1061' },
        { value: '700', text: 'Montserrat', id:'700' },
        { value: '1057', text: 'Morocco', id:'1057' },
        { value: '710', text: 'Mozambique', id:'710' },
        { value: '1060', text: 'Myanmar', id:'1060' },
        { value: '715', text: 'Namibia', id:'715' },
        { value: '720', text: 'Nepal', id:'720' },
        { value: '47', text: 'Netherlands', id:'47' },
        { value: '730', text: 'New Zealand', id:'730' },
        { value: '735', text: 'Nicaragua', id:'735' },
        { value: '740', text: 'Niger', id:'740' },
        { value: '1063', text: 'Nigeria', id:'1063' },
        { value: '745', text: 'North Pole', id:'745' },
        // { value: '750', text: 'Northern Ireland', id:'750' },
        { value: '49', text: 'Norway', id:'49' },
        { value: '760', text: 'Oman', id:'760' },
        { value: '765', text: 'Pakistan', id:'765' },
        // { value: '1065', text: 'Palestine', id:'1065' },
        { value: '770', text: 'Panama', id:'770' },
        { value: '1064', text: 'Papua New Guinea', id:'1064' },
        { value: '775', text: 'Paraguay', id:'775' },
        { value: '780', text: 'Peru', id:'780' },
        { value: '785', text: 'Philippines', id:'785' },
        { value: '53', text: 'Poland', id:'53' },
        { value: '54', text: 'Portugal', id:'54' },
        { value: '800', text: 'Puerto Rico', id:'800' },
        { value: '805', text: 'Qatar', id:'805' },
        { value: '19', text: 'Ireland', id:'19' },
        { value: '630', text: 'North Macedonia', id:'630' },
        { value: '55', text: 'Romania', id:'55' },
        { value: '820', text: 'Russia', id:'820' },
        { value: '830', text: 'Rwanda', id:'830' },
        { value: '1078', text: 'Saint Vincent', id:'1078' },
        { value: '835', text: 'Samoa', id:'835' },
        { value: '290', text: 'San Marino', id:'290' },
        { value: '1042', text: 'Saudi Arabia', id:'1042' },
        { value: '840', text: 'Senegal', id:'840' },
        { value: '845', text: 'Serbia', id:'845' },
        { value: '850', text: 'Seychelles', id:'850' },
        { value: '1069', text: 'Sierra Leone', id:'1069' },
        { value: '855', text: 'Singapore', id:'855' },
        { value: '59', text: 'Slovakia', id:'59' },
        { value: '60', text: 'Slovenia', id:'60' },
        { value: '1068', text: 'Solomon Islands', id:'1068' },
        { value: '1070', text: 'Somalia', id:'1070' },
        { value: '875', text: 'South Africa', id:'875' },
        { value: '62', text: 'Spain', id:'62' },
        { value: '885', text: 'Sri Lanka', id:'885' },
        { value: '890', text: 'St Helena', id:'890' },
        { value: '895', text: 'Saint Lucia', id:'895' },
        { value: '1082', text: 'Sudan', id:'1082' },
        { value: '900', text: 'Eswatini', id:'900' },
        { value: '63', text: 'Sweden', id:'63' },
        { value: '285', text: 'Switzerland', id:'285' },
        { value: '1076', text: 'Taiwan', id:'1076' },
        { value: '1072', text: 'Tajikistan', id:'1072' },
        { value: '920', text: 'Tanzania', id:'920' },
        { value: '925', text: 'Thailand', id:'925' },
        { value: '930', text: 'Tibet', id:'930' },
        { value: '1073', text: 'Timor-Leste', id:'1073' },
        { value: '935', text: 'Togo', id:'935' },
        { value: '940', text: 'Tonga', id:'940' },
        { value: '945', text: 'Trinidad & Tobago', id:'945' },
        { value: '1074', text: 'Tunisia', id:'1074' },
        { value: '1075', text: 'Turkey', id:'1075' },
        { value: '960', text: 'Turkmenistan', id:'960' },
        { value: '1071', text: 'Turks and Caicos Islands', id:'1071' },
        { value: '965', text: 'Tuvalu', id:'965' },
        { value: '975', text: 'Uganda', id:'975' },
        { value: '980', text: 'Ukraine', id:'980' },
        { value: '985', text: 'United Arab Emirates', id:'985' },
        { value: '70', text: 'United Kingdom', id:'70' },
        { value: '995', text: 'Uruguay', id:'995' },
        { value: '1077', text: 'USA', id:'1077' },
        { value: '1000', text: 'Uzbekistan', id:'1000' },
        { value: '291', text: 'Vatican City', id:'291' },
        { value: '1005', text: 'Venezuela', id:'1005' },
        { value: '1010', text: 'Vietnam', id:'1010' },
        { value: '1015', text: 'Virgin Islands', id:'1015' },
        { value: '1020', text: 'West Indies', id:'1020' },
        { value: '1079', text: 'Yemen', id:'1079' },
        { value: '1030', text: 'Congo (DRC)', id:'1030' },
        { value: '1035', text: 'Zambia', id:'1035' },
        { value: '1040', text: 'Zimbabwe', id:'1040' }
]

export const countrysTo = [
        // disabled countries in comment
        // { value: '5', text: 'Afghanistan', id:'5' },
        { value: '10', text: 'Alaska', id:'10' },
        { value: '15', text: 'Albania', id:'15' },
        { value: '20', text: 'Algeria', id:'20' },
        { value: '25', text: 'Andorra', id:'25' },
        { value: '30', text: 'Angola', id:'30' },
        { value: '35', text: 'Anguilla', id:'35' },
        { value: '40', text: 'Antarctica', id:'40' },
        { value: '45', text: 'Antigua', id:'45' },
        { value: '1067', text: 'Antilles', id:'1067' },
        { value: '50', text: 'Argentina', id:'50' },
        { value: '55', text: 'Armenia', id:'55' },
        { value: '60', text: 'Aruba', id:'60' },
        { value: '65', text: 'Ascension Island', id:'65' },
        { value: '70', text: 'Australia', id:'70' },
        { value: '75', text: 'Austria', id:'75' },
        { value: '80', text: 'Azerbaijan', id:'80' },
        { value: '85', text: 'Azores', id:'85' },
        { value: '90', text: 'Bahamas', id:'90' },
        { value: '95', text: 'Bahrain', id:'95' },
        { value: '100', text: 'Bali', id:'100' },
        { value: '105', text: 'Bangladesh', id:'105' },
        { value: '110', text: 'Barbados', id:'110' },
        { value: '115', text: 'Barbuda', id:'115' },
        // { value: '120', text: 'Belarus', id:'120' },
        { value: '125', text: 'Belgium', id:'125' },
        { value: '130', text: 'Belize', id:'130' },
        { value: '135', text: 'Benin', id:'135' },
        { value: '140', text: 'Bermuda', id:'140' },
        { value: '145', text: 'Bhutan', id:'145' },
        { value: '150', text: 'Bolivia', id:'150' },
        { value: '155', text: 'Bosnia and Herzegovina', id:'155' },
        { value: '160', text: 'Botswana', id:'160' },
        { value: '165', text: 'Brazil', id:'165' },
        { value: '170', text: 'Brunei', id:'170' },
        { value: '175', text: 'Bulgaria', id:'175' },
        { value: '180', text: 'Burkina Faso', id:'180' },
        { value: '190', text: 'Burundi', id:'190' },
        { value: '195', text: 'Cambodia', id:'195' },
        { value: '200', text: 'Cameroon', id:'200' },
        { value: '205', text: 'Canada', id:'205' },
        { value: '210', text: 'Canary Islands', id:'210' },
        { value: '215', text: 'Cape Verde', id:'215' },
        { value: '220', text: 'Cayman Islands', id:'220' },
        // { value: '225', text: 'Central African Republic', id:'225' },
        { value: '230', text: 'Chad', id:'230' },
        { value: '240', text: 'Chile', id:'240' },
        { value: '245', text: 'China', id:'245' },
        { value: '250', text: 'Colombia', id:'250' },
        { value: '255', text: 'Comoros', id:'255' },
        // { value: '260', text: 'Congo', id:'260' },
        { value: '265', text: 'Cook Islands', id:'265' },
        { value: '270', text: 'Costa Rica', id:'270' },
        { value: '280', text: 'Croatia', id:'280' },
        { value: '285', text: 'Cuba', id:'285' },
        { value: '1043', text: 'Curacao', id:'1043' },
        { value: '290', text: 'Cyprus', id:'290' },
        { value: '295', text: 'Czech Republic', id:'295' },
        { value: '300', text: 'Denmark', id:'300' },
        { value: '305', text: 'Djibouti', id:'305' },
        { value: '310', text: 'Dominica', id:'310' },
        { value: '315', text: 'Dominican Republic', id:'315' },
        { value: '320', text: 'Ecuador', id:'320' },
        { value: '325', text: 'Egypt', id:'325' },
        { value: '335', text: 'El Salvador', id:'335' },
        { value: '340', text: 'Equatorial Guinea', id:'340' },
        { value: '345', text: 'Eritrea', id:'345' },
        { value: '350', text: 'Estonia', id:'350' },
        { value: '355', text: 'Ethiopia', id:'355' },
        { value: '360', text: 'Falkland Islands', id:'360' },
        { value: '1066', text: 'Faroe Islands', id:'1066' },
        { value: '365', text: 'Fiji', id:'365' },
        { value: '370', text: 'Finland', id:'370' },
        { value: '375', text: 'France', id:'375' },
        { value: '1064', text: 'French Guiana', id:'1064' },
        { value: '1056', text: 'French Polynesia', id:'1056' },
        { value: '380', text: 'Gabon', id:'380' },
        { value: '385', text: 'Gambia', id:'385' },
        { value: '390', text: 'Georgia', id:'390' },
        { value: '395', text: 'Germany', id:'395' },
        { value: '400', text: 'Ghana', id:'400' },
        { value: '405', text: 'Gibraltar', id:'405' },
        { value: '410', text: 'Greece', id:'410' },
        { value: '415', text: 'Greenland', id:'415' },
        { value: '420', text: 'Grenada', id:'420' },
        { value: '1065', text: 'Guadeloupe', id:'1065' },
        { value: '425', text: 'Guam', id:'425' },
        { value: '430', text: 'Guatemala', id:'430' },
        { value: '435', text: 'Guernsey', id:'435' },
        { value: '440', text: 'Guinea', id:'440' },
        { value: '450', text: 'Guinea-Bissau', id:'450' },
        { value: '455', text: 'Guyana', id:'455' },
        { value: '460', text: 'Haiti', id:'460' },
        { value: '470', text: 'Honduras', id:'470' },
        { value: '475', text: 'Hong Kong', id:'475' },
        { value: '480', text: 'Hungary', id:'480' },
        { value: '485', text: 'Iceland', id:'485' },
        { value: '490', text: 'India', id:'490' },
        { value: '495', text: 'Indonesia', id:'495' },
        // { value: '500', text: 'Iran', id:'500' },
        // { value: '505', text: 'Iraq', id:'505' },
        { value: '510', text: 'Ireland', id:'510' },
        { value: '515', text: 'Isle of Man', id:'515' },
        { value: '520', text: 'Israel', id:'520' },
        { value: '525', text: 'Italy', id:'525' },
        { value: '530', text: 'Côte d’Ivoire', id:'530' },
        { value: '535', text: 'Jamaica', id:'535' },
        { value: '540', text: 'Japan', id:'540' },
        { value: '545', text: 'Jersey', id:'545' },
        { value: '550', text: 'Jordan', id:'550' },
        { value: '1044', text: 'Kazakhstan', id:'1044' },
        { value: '555', text: 'Kenya', id:'555' },
        { value: '560', text: 'Kiribati', id:'560' },
        // { value: '570', text: 'North Korea', id:'570' },
        { value: '575', text: 'South Korea', id:'575' },
        { value: '1041', text: 'Kosovo', id:'1041' },
        { value: '580', text: 'Kuwait', id:'580' },
        { value: '1063', text: 'Kyrgyzstan', id:'1063' },
        { value: '585', text: 'Laos', id:'585' },
        { value: '590', text: 'Latvia', id:'590' },
        { value: '595', text: 'Lebanon', id:'595' },
        { value: '600', text: 'Lesotho', id:'600' },
        { value: '605', text: 'Liberia', id:'605' },
        // { value: '610', text: 'Libya', id:'610' },
        { value: '615', text: 'Liechtenstein', id:'615' },
        { value: '620', text: 'Lithuania', id:'620' },
        { value: '625', text: 'Luxembourg', id:'625' },
        { value: '1062', text: 'Macao', id:'1062' },
        { value: '635', text: 'Madagascar', id:'635' },
        { value: '640', text: 'Madeira', id:'640' },
        { value: '645', text: 'Malawi', id:'645' },
        { value: '650', text: 'Malaysia', id:'650' },
        { value: '655', text: 'Maldives', id:'655' },
        { value: '660', text: 'Malta', id:'660' },
        { value: '1069', text: 'Marshall Islands', id:'1069' },
        { value: '1060', text: 'Martinique', id:'1060' },
        { value: '665', text: 'Mauritania', id:'665' },
        { value: '670', text: 'Mauritius', id:'670' },
        { value: '675', text: 'Mexico', id:'675' },
        { value: '680', text: 'Moldova', id:'680' },
        { value: '685', text: 'Monaco', id:'685' },
        { value: '690', text: 'Mongolia', id:'690' },
        { value: '695', text: 'Montenegro', id:'695' },
        { value: '700', text: 'Montserrat', id:'700' },
        { value: '705', text: 'Morocco', id:'705' },
        { value: '710', text: 'Mozambique', id:'710' },
        { value: '1061', text: 'Myanmar', id:'1061' },
        { value: '715', text: 'Namibia', id:'715' },
        { value: '720', text: 'Nepal', id:'720' },
        { value: '725', text: 'Netherlands', id:'725' },
        { value: '730', text: 'New Zealand', id:'730' },
        { value: '735', text: 'Nicaragua', id:'735' },
        // { value: '740', text: 'Niger', id:'740' },
        { value: '1059', text: 'Nigeria', id:'1059' },
        { value: '745', text: 'North Pole', id:'745' },
        { value: '750', text: 'Northern Ireland', id:'750' },
        { value: '755', text: 'Norway', id:'755' },
        { value: '760', text: 'Oman', id:'760' },
        { value: '765', text: 'Pakistan', id:'765' },
        // { value: '1057', text: 'Palestine', id:'1057' },
        { value: '770', text: 'Panama', id:'770' },
        { value: '1058', text: 'Papua New Guinea', id:'1058' },
        { value: '775', text: 'Paraguay', id:'775' },
        { value: '780', text: 'Peru', id:'780' },
        { value: '785', text: 'Philippines', id:'785' },
        { value: '790', text: 'Poland', id:'790' },
        { value: '795', text: 'Portugal', id:'795' },
        { value: '800', text: 'Puerto Rico', id:'800' },
        { value: '805', text: 'Qatar', id:'805' },
        { value: '630', text: 'North Macedonia', id:'630' },
        { value: '815', text: 'Romania', id:'815' },
        // { value: '820', text: 'Russia', id:'820' },
        // { value: '825', text: 'Russia (West of the Ural Mount)', id:'825' },
        { value: '830', text: 'Rwanda', id:'830' },
        { value: '1070', text: 'Saint Martin', id:'1070' },
        { value: '1049', text: 'Saint Vincent', id:'1049' },
        { value: '835', text: 'Samoa', id:'835' },
        { value: '1047', text: 'San Marino', id:'1047' },
        { value: '1042', text: 'Saudi Arabia', id:'1042' },
        { value: '840', text: 'Senegal', id:'840' },
        { value: '845', text: 'Serbia', id:'845' },
        { value: '850', text: 'Seychelles', id:'850' },
        { value: '1054', text: 'Sierra Leone', id:'1054' },
        { value: '855', text: 'Singapore', id:'855' },
        { value: '860', text: 'Slovakia', id:'860' },
        { value: '865', text: 'Slovenia', id:'865' },
        { value: '1055', text: 'Solomon Islands', id:'1055' },
        // { value: '870', text: 'Somalia', id:'870' },
        { value: '875', text: 'South Africa', id:'875' },
        { value: '880', text: 'Spain', id:'880' },
        { value: '885', text: 'Sri Lanka', id:'885' },
        { value: '890', text: 'St Helena', id:'890' },
        { value: '895', text: 'Saint Lucia', id:'895' },
        // { value: '1068', text: 'Sudan', id:'1068' },
        { value: '900', text: 'Eswatini', id:'900' },
        { value: '905', text: 'Sweden', id:'905' },
        { value: '910', text: 'Switzerland', id:'910' },
        // { value: '915', text: 'Syria', id:'915' },
        { value: '1050', text: 'Taiwan', id:'1050' },
        { value: '1052', text: 'Tajikistan', id:'1052' },
        { value: '920', text: 'Tanzania', id:'920' },
        { value: '925', text: 'Thailand', id:'925' },
        { value: '1051', text: 'Timor-Leste', id:'1051' },
        { value: '935', text: 'Togo', id:'935' },
        { value: '940', text: 'Tonga', id:'940' },
        { value: '945', text: 'Trinidad & Tobago', id:'945' },
        { value: '950', text: 'Tunisia', id:'950' },
        { value: '955', text: 'Turkey', id:'955' },
        { value: '960', text: 'Turkmenistan', id:'960' },
        { value: '1053', text: 'Turks and Caicos Islands', id:'1053' },
        { value: '965', text: 'Tuvalu', id:'965' },
        { value: '975', text: 'Uganda', id:'975' },
        // { value: '980', text: 'Ukraine', id:'980' },
        { value: '985', text: 'United Arab Emirates', id:'985' },
        { value: '990', text: 'United Kingdom', id:'990' },
        { value: '995', text: 'Uruguay', id:'995' },
        { value: '970', text: 'USA', id:'970' },
        { value: '1000', text: 'Uzbekistan', id:'1000' },
        { value: '1045', text: 'Vatican City', id:'1045' },
        // { value: '1005', text: 'Venezuela', id:'1005' },
        { value: '1010', text: 'Vietnam', id:'1010' },
        { value: '1015', text: 'Virgin Islands', id:'1015' },
        { value: '1020', text: 'West Indies', id:'1020' },
        // { value: '1025', text: 'Yemen', id:'1025' },
        { value: '1030', text: 'Congo (DRC)', id:'1030' },
        { value: '1035', text: 'Zambia', id:'1035' },
        { value: '1040', text: 'Zimbabwe', id:'1040' }
]

export const countryVia = [
        // disabled countries in comment
        // { value: '5', text: 'Afghanistan', id:'5' },
        { value: '10', text: 'Alaska', id:'10' },
        { value: '15', text: 'Albania', id:'15' },
        { value: '20', text: 'Algeria', id:'20' },
        { value: '25', text: 'Andorra', id:'25' },
        { value: '30', text: 'Angola', id:'30' },
        { value: '35', text: 'Anguilla', id:'35' },
        { value: '40', text: 'Antarctica', id:'40' },
        { value: '45', text: 'Antigua', id:'45' },
        { value: '1067', text: 'Antilles', id:'1067' },
        { value: '50', text: 'Argentina', id:'50' },
        { value: '55', text: 'Armenia', id:'55' },
        { value: '60', text: 'Aruba', id:'60' },
        { value: '65', text: 'Ascension Island', id:'65' },
        { value: '70', text: 'Australia', id:'70' },
        { value: '75', text: 'Austria', id:'75' },
        { value: '80', text: 'Azerbaijan', id:'80' },
        { value: '85', text: 'Azores', id:'85' },
        { value: '90', text: 'Bahamas', id:'90' },
        { value: '95', text: 'Bahrain', id:'95' },
        { value: '100', text: 'Bali', id:'100' },
        { value: '105', text: 'Bangladesh', id:'105' },
        { value: '110', text: 'Barbados', id:'110' },
        { value: '115', text: 'Barbuda', id:'115' },
        // { value: '120', text: 'Belarus', id:'120' },
        { value: '125', text: 'Belgium', id:'125' },
        { value: '130', text: 'Belize', id:'130' },
        { value: '135', text: 'Benin', id:'135' },
        { value: '140', text: 'Bermuda', id:'140' },
        { value: '145', text: 'Bhutan', id:'145' },
        { value: '150', text: 'Bolivia', id:'150' },
        { value: '155', text: 'Bosnia and Herzegovina', id:'155' },
        { value: '160', text: 'Botswana', id:'160' },
        { value: '165', text: 'Brazil', id:'165' },
        { value: '170', text: 'Brunei', id:'170' },
        { value: '175', text: 'Bulgaria', id:'175' },
        { value: '180', text: 'Burkina Faso', id:'180' },
        { value: '190', text: 'Burundi', id:'190' },
        { value: '195', text: 'Cambodia', id:'195' },
        { value: '200', text: 'Cameroon', id:'200' },
        { value: '205', text: 'Canada', id:'205' },
        { value: '210', text: 'Canary Islands', id:'210' },
        { value: '215', text: 'Cape Verde', id:'215' },
        { value: '220', text: 'Cayman Islands', id:'220' },
        // { value: '225', text: 'Central African Republic', id:'225' },
        { value: '230', text: 'Chad', id:'230' },
        { value: '240', text: 'Chile', id:'240' },
        { value: '245', text: 'China', id:'245' },
        { value: '250', text: 'Colombia', id:'250' },
        { value: '255', text: 'Comoros', id:'255' },
        // { value: '260', text: 'Congo', id:'260' },
        { value: '265', text: 'Cook Islands', id:'265' },
        { value: '270', text: 'Costa Rica', id:'270' },
        { value: '280', text: 'Croatia', id:'280' },
        { value: '285', text: 'Cuba', id:'285' },
        { value: '1043', text: 'Curacao', id:'1043' },
        { value: '290', text: 'Cyprus', id:'290' },
        { value: '295', text: 'Czech Republic', id:'295' },
        { value: '300', text: 'Denmark', id:'300' },
        { value: '305', text: 'Djibouti', id:'305' },
        { value: '310', text: 'Dominica', id:'310' },
        { value: '315', text: 'Dominican Republic', id:'315' },
        { value: '320', text: 'Ecuador', id:'320' },
        { value: '325', text: 'Egypt', id:'325' },
        { value: '335', text: 'El Salvador', id:'335' },
        { value: '340', text: 'Equatorial Guinea', id:'340' },
        { value: '345', text: 'Eritrea', id:'345' },
        { value: '350', text: 'Estonia', id:'350' },
        { value: '355', text: 'Ethiopia', id:'355' },
        { value: '360', text: 'Falkland Islands', id:'360' },
        { value: '1066', text: 'Faroe Islands', id:'1066' },
        { value: '365', text: 'Fiji', id:'365' },
        { value: '370', text: 'Finland', id:'370' },
        { value: '375', text: 'France', id:'375' },
        { value: '1064', text: 'French Guiana', id:'1064' },
        { value: '1056', text: 'French Polynesia', id:'1056' },
        { value: '380', text: 'Gabon', id:'380' },
        { value: '385', text: 'Gambia', id:'385' },
        { value: '390', text: 'Georgia', id:'390' },
        { value: '395', text: 'Germany', id:'395' },
        { value: '400', text: 'Ghana', id:'400' },
        { value: '405', text: 'Gibraltar', id:'405' },
        { value: '410', text: 'Greece', id:'410' },
        { value: '415', text: 'Greenland', id:'415' },
        { value: '420', text: 'Grenada', id:'420' },
        { value: '1065', text: 'Guadeloupe', id:'1065' },
        { value: '425', text: 'Guam', id:'425' },
        { value: '430', text: 'Guatemala', id:'430' },
        { value: '435', text: 'Guernsey', id:'435' },
        { value: '440', text: 'Guinea', id:'440' },
        { value: '450', text: 'Guinea-Bissau', id:'450' },
        { value: '455', text: 'Guyana', id:'455' },
        { value: '460', text: 'Haiti', id:'460' },
        { value: '470', text: 'Honduras', id:'470' },
        { value: '475', text: 'Hong Kong', id:'475' },
        { value: '480', text: 'Hungary', id:'480' },
        { value: '485', text: 'Iceland', id:'485' },
        { value: '490', text: 'India', id:'490' },
        { value: '495', text: 'Indonesia', id:'495' },
        // { value: '500', text: 'Iran', id:'500' },
        // { value: '505', text: 'Iraq', id:'505' },
        { value: '510', text: 'Ireland', id:'510' },
        { value: '515', text: 'Isle of Man', id:'515' },
        { value: '520', text: 'Israel', id:'520' },
        { value: '525', text: 'Italy', id:'525' },
        { value: '530', text: 'Côte d’Ivoire', id:'530' },
        { value: '535', text: 'Jamaica', id:'535' },
        { value: '540', text: 'Japan', id:'540' },
        { value: '545', text: 'Jersey', id:'545' },
        { value: '550', text: 'Jordan', id:'550' },
        { value: '1044', text: 'Kazakhstan', id:'1044' },
        { value: '555', text: 'Kenya', id:'555' },
        { value: '560', text: 'Kiribati', id:'560' },
        // { value: '570', text: 'North Korea', id:'570' },
        { value: '575', text: 'South Korea', id:'575' },
        { value: '1041', text: 'Kosovo', id:'1041' },
        { value: '580', text: 'Kuwait', id:'580' },
        { value: '1063', text: 'Kyrgyzstan', id:'1063' },
        { value: '585', text: 'Laos', id:'585' },
        { value: '590', text: 'Latvia', id:'590' },
        { value: '595', text: 'Lebanon', id:'595' },
        { value: '600', text: 'Lesotho', id:'600' },
        { value: '605', text: 'Liberia', id:'605' },
        // { value: '610', text: 'Libya', id:'610' },
        { value: '615', text: 'Liechtenstein', id:'615' },
        { value: '620', text: 'Lithuania', id:'620' },
        { value: '625', text: 'Luxembourg', id:'625' },
        { value: '1062', text: 'Macao', id:'1062' },
        { value: '635', text: 'Madagascar', id:'635' },
        { value: '640', text: 'Madeira', id:'640' },
        { value: '645', text: 'Malawi', id:'645' },
        { value: '650', text: 'Malaysia', id:'650' },
        { value: '655', text: 'Maldives', id:'655' },
        { value: '660', text: 'Malta', id:'660' },
        { value: '1069', text: 'Marshall Islands', id:'1069' },
        { value: '1060', text: 'Martinique', id:'1060' },
        { value: '665', text: 'Mauritania', id:'665' },
        { value: '670', text: 'Mauritius', id:'670' },
        { value: '675', text: 'Mexico', id:'675' },
        { value: '680', text: 'Moldova', id:'680' },
        { value: '685', text: 'Monaco', id:'685' },
        { value: '690', text: 'Mongolia', id:'690' },
        { value: '695', text: 'Montenegro', id:'695' },
        { value: '700', text: 'Montserrat', id:'700' },
        { value: '705', text: 'Morocco', id:'705' },
        { value: '710', text: 'Mozambique', id:'710' },
        { value: '1061', text: 'Myanmar', id:'1061' },
        { value: '715', text: 'Namibia', id:'715' },
        { value: '720', text: 'Nepal', id:'720' },
        { value: '725', text: 'Netherlands', id:'725' },
        { value: '730', text: 'New Zealand', id:'730' },
        { value: '735', text: 'Nicaragua', id:'735' },
        // { value: '740', text: 'Niger', id:'740' },
        { value: '1059', text: 'Nigeria', id:'1059' },
        { value: '745', text: 'North Pole', id:'745' },
        { value: '750', text: 'Northern Ireland', id:'750' },
        { value: '755', text: 'Norway', id:'755' },
        { value: '760', text: 'Oman', id:'760' },
        { value: '765', text: 'Pakistan', id:'765' },
        // { value: '1057', text: 'Palestine', id:'1057' },
        { value: '770', text: 'Panama', id:'770' },
        { value: '1058', text: 'Papua New Guinea', id:'1058' },
        { value: '775', text: 'Paraguay', id:'775' },
        { value: '780', text: 'Peru', id:'780' },
        { value: '785', text: 'Philippines', id:'785' },
        { value: '790', text: 'Poland', id:'790' },
        { value: '795', text: 'Portugal', id:'795' },
        { value: '800', text: 'Puerto Rico', id:'800' },
        { value: '805', text: 'Qatar', id:'805' },
        { value: '630', text: 'North Macedonia', id:'630' },
        { value: '815', text: 'Romania', id:'815' },
        // { value: '820', text: 'Russia', id:'820' },
        // { value: '825', text: 'Russia (West of the Ural Mount)', id:'825' },
        { value: '830', text: 'Rwanda', id:'830' },
        { value: '1070', text: 'Saint Martin', id:'1070' },
        { value: '1049', text: 'Saint Vincent', id:'1049' },
        { value: '835', text: 'Samoa', id:'835' },
        { value: '1047', text: 'San Marino', id:'1047' },
        { value: '1042', text: 'Saudi Arabia', id:'1042' },
        { value: '840', text: 'Senegal', id:'840' },
        { value: '845', text: 'Serbia', id:'845' },
        { value: '850', text: 'Seychelles', id:'850' },
        { value: '1054', text: 'Sierra Leone', id:'1054' },
        { value: '855', text: 'Singapore', id:'855' },
        { value: '860', text: 'Slovakia', id:'860' },
        { value: '865', text: 'Slovenia', id:'865' },
        { value: '1055', text: 'Solomon Islands', id:'1055' },
        // { value: '870', text: 'Somalia', id:'870' },
        { value: '875', text: 'South Africa', id:'875' },
        { value: '880', text: 'Spain', id:'880' },
        { value: '885', text: 'Sri Lanka', id:'885' },
        { value: '890', text: 'St Helena', id:'890' },
        { value: '895', text: 'Saint Lucia', id:'895' },
        // { value: '1068', text: 'Sudan', id:'1068' },
        { value: '900', text: 'Eswatini', id:'900' },
        { value: '905', text: 'Sweden', id:'905' },
        { value: '910', text: 'Switzerland', id:'910' },
        // { value: '915', text: 'Syria', id:'915' },
        { value: '1050', text: 'Taiwan', id:'1050' },
        { value: '1052', text: 'Tajikistan', id:'1052' },
        { value: '920', text: 'Tanzania', id:'920' },
        { value: '925', text: 'Thailand', id:'925' },
        { value: '1051', text: 'Timor-Leste', id:'1051' },
        { value: '935', text: 'Togo', id:'935' },
        { value: '940', text: 'Tonga', id:'940' },
        { value: '945', text: 'Trinidad & Tobago', id:'945' },
        { value: '950', text: 'Tunisia', id:'950' },
        { value: '955', text: 'Turkey', id:'955' },
        { value: '960', text: 'Turkmenistan', id:'960' },
        { value: '1053', text: 'Turks and Caicos Islands', id:'1053' },
        { value: '965', text: 'Tuvalu', id:'965' },
        { value: '975', text: 'Uganda', id:'975' },
        // { value: '980', text: 'Ukraine', id:'980' },
        { value: '985', text: 'United Arab Emirates', id:'985' },
        { value: '990', text: 'United Kingdom', id:'990' },
        { value: '995', text: 'Uruguay', id:'995' },
        { value: '970', text: 'USA', id:'970' },
        { value: '1000', text: 'Uzbekistan', id:'1000' },
        { value: '1045', text: 'Vatican City', id:'1045' },
        // { value: '1005', text: 'Venezuela', id:'1005' },
        { value: '1010', text: 'Vietnam', id:'1010' },
        { value: '1015', text: 'Virgin Islands', id:'1015' },
        { value: '1020', text: 'West Indies', id:'1020' },
        // { value: '1025', text: 'Yemen', id:'1025' },
        { value: '1030', text: 'Congo (DRC)', id:'1030' },
        { value: '1035', text: 'Zambia', id:'1035' },
        { value: '1040', text: 'Zimbabwe', id:'1040' }
]

export const agentRoutesMixin = {
  computed: {
    route() {
      return (name) => {
        const agent = store.state.agent
        if (agent && agent !== '1dbaa403b94ccdd1991c3afd511858a5') {
          return { name, query: { agent } }
        }
        return { name }
      }
    },
    hasAgent() {
      const agent = store.state.agent
      return agent && agent !== '1dbaa403b94ccdd1991c3afd511858a5'
    }
  }
}